import jinjaToJS from "jinja-to-js";import __$0 from "./filter_previews/filter_previews";export default function templateModulesFilterPreviewsSuggestedDesigner(ctx) {
    var __result = "";
    var __tmp;
    var __runtime = jinjaToJS.runtime;
    var __filters = jinjaToJS.filters;
    var __globals = jinjaToJS.globals;
    var context = jinjaToJS.createContext(ctx);
    if(__runtime.boolean(context.filter_previews)){__result += "\n    <div class=\"filter-previews__suggested-designers\">\n        ";__result += "" + ((__tmp = (__$0(context))) == null ? "" : __tmp);__result += "\n    </div>\n";}
    return __result;
}